import { render } from "./SaveSection.vue?vue&type=template&id=158c8c72"
import script from "./SaveSection.vue?vue&type=script&lang=js"
export * from "./SaveSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__